import React from "react";
import ScreenshotCard from "../../incbotFeedback/ScreenshotCard";
import { useSelector } from "react-redux";
import { getFeedbackForm } from "../../../../redux/reducer/incbotFeedbackReducer";

const ScreenshotsView: React.FC = () => {
  const feedbackForm = useSelector(getFeedbackForm);
  const screenshots =
    feedbackForm?.screenshots?.images?.map((imageUrl: string, index: number) => ({
      title: `Screenshot #${index + 1}`,
      imageUrl,
    })) || [];
  const deviceScreenshots =
    feedbackForm?.deviceScreenshots?.images?.map((imageUrl: string, index: number) => ({
      title: `Screenshot #${index + 1}`,
      imageUrl,
    })) || [];

  return (
    <div className="p-3 md:p-6">
      <div className="md:hidden print:flex w-100 p-1 print:p-2 rounded-md border-b-4 border-teal-500 bg-teal-50 text-teal-500 text-md print:text-xl flex justify-center font-semibold mb-3 md:mb-6">
        Screenshots
      </div>
      <div>
        <p className="text-md md:text-lg text-gray-600 font-semibold mb-2 md:mb-4">
          Candidate Screenshots:
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6">
          {screenshots.map((screenshot: { title: string; imageUrl: string }, index: number) => (
            <ScreenshotCard key={index} title={screenshot.title} imageUrl={screenshot.imageUrl} />
          ))}
        </div>
      </div>
      {deviceScreenshots.length > 0 && (
        <div className="mt-3 md:mt-6">
          <p className="text-md md:text-lg text-gray-600 font-semibold mb-2 md:mb-4">
            Device Screenshots:
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6">
            {deviceScreenshots.map(
              (screenshot: { title: string; imageUrl: string }, index: number) => (
                <ScreenshotCard
                  key={index}
                  title={screenshot.title}
                  imageUrl={screenshot.imageUrl}
                />
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ScreenshotsView;
